import { httpClient } from '../../../shared/api/httpClient';

export interface Template {
  id: string;
  name: string;
  content: string;
  category?: string;
}

export async function getTemplates(search?: string, category?: string): Promise<Template[]> {
  const params = new URLSearchParams();
  if (search) {
    params.append('search', search);
  }
  if (category) {
    params.append('category', category);
  }
  
  const queryString = params.toString();
  const url = queryString ? `/templates/?${queryString}` : '/templates/';
  return httpClient.get<Template[]>(url);
}

export async function createTemplate(data: {
  name: string;
  content: string;
  category?: string;
}): Promise<Template> {
  return httpClient.post<Template>('/templates/', data);
}

export async function updateTemplate(id: string, data: Partial<Template>): Promise<Template> {
  return httpClient.put<Template>(`/templates/${id}/`, data);
}

export async function deleteTemplate(id: string): Promise<void> {
  return httpClient.delete(`/templates/${id}/`);
}

